// Business Mastery — shared config + analytics helpers. Extends existing analytics (lib/analytics).
import api from "@/lib/api";
import { track } from "@/lib/analytics";

// Real approved cover asset (uploaded by owner). Components fall back to a branded
// placeholder tile automatically if the file is not present yet.
export const COVER_SRC = "/assets/business-mastery-cover.png";

// Topics where the book is genuinely relevant. Used to place in-lesson Recommended Reading sparsely.
const RELEVANT_KEYWORDS = [
  "entrepreneur", "foundation", "ownership", "owner", "business plan", "planning",
  "system", "operation", "leadership", "leader", "growth", "grow", "scal", "mindset",
  "idea to launch", "launch", "forming", "develop",
];
export function isRelevantLesson({ courseTitle = "", lessonTitle = "", pathTitle = "" } = {}) {
  const hay = `${pathTitle} ${courseTitle} ${lessonTitle}`.toLowerCase();
  return RELEVANT_KEYWORDS.some((k) => hay.includes(k));
}

export const BOOK = {
  title: "Business Mastery",
  author: "Calvin Langford",
  amazonUrl: "https://www.amazon.com/dp/B0H7QGFM95",
  tagline: "A practical business education resource for entrepreneurs, founders, and small-business owners.",
  description:
    "Business Mastery by Calvin Langford is a practical business education resource for entrepreneurs, aspiring founders, and small-business owners. It walks through building, systemizing, and growing a business — and includes hands-on exercises at the end of its chapters to help you apply what you read.",
  learn: [
    "Business foundations and the owner's mindset",
    "Planning and building durable business systems",
    "Operations, leadership, and long-term growth",
    "Applying each chapter through end-of-chapter exercises",
  ],
  who: [
    "Aspiring and first-time entrepreneurs",
    "Founders building and organizing a new business",
    "Small-business owners systemizing for growth",
  ],
};

// Fire-and-forget; extends existing first-party analytics. Never records a click as a purchase.
// opts.public routes through the anonymous /public/track endpoint (for public pages like /demo/video).
export function bmTrack(event, props = {}, opts = {}) {
  if (opts.public) {
    api.post("/public/track", { event, book: "business_mastery", ...props }).catch(() => {});
    return;
  }
  track(event, { book: "business_mastery", ...props });
}
export const BM_EVENTS = {
  view: "business_mastery_view",
  purchaseClick: "business_mastery_purchase_click",
  referralClick: "business_mastery_course_referral_click",
};

export function openAmazon(props = {}, opts = {}) {
  bmTrack(BM_EVENTS.purchaseClick, props, opts); // a click is NOT a confirmed sale
  window.open(BOOK.amazonUrl, "_blank", "noopener,noreferrer");
}
